module.exports = __webpack_public_path__ + "static/media/logo_reviewer.cf443cd0.svg";